import React, { useEffect } from 'react';
import { Empty, Typography, Tag } from 'antd';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { Loading3QuartersOutlined } from '@ant-design/icons';
import {
  fetchWebChatChannelList,
  getWebChatChannelData,
} from '../../../../reduxToolkit/channelSlice';
import { useSearchParams } from 'react-router-dom';
const { Text } = Typography;
// status

const status = {
  8: 'Ready',
  10: 'Active',
};

const WebChatChannels = () => {
  // hooks
  const dispatch = useDispatch();
  const [searchParams, setSearchParams] = useSearchParams();

  // selectors
  const {
    selectedWebChatChannel,
    webChatChannelList,
    webChatChannelListLoading,
  } = useSelector((state) => state.Channel);
  const { currentBrand } = useSelector((state) => state.app);

  // Handlers
  const handleSelectChannel = async (channel) => {
    const res = await dispatch(
      getWebChatChannelData({
        brand_id: currentBrand?.brand_id,
        channel: channel.id,
      }),
    );

    if (res?.type === 'webChat/get_webChat_channel_data/fulfilled') {
      if (searchParams.has('channel')) {
        searchParams.delete('channel');
        setSearchParams(searchParams);
      }
    }

    // remove the channel from the url
  };

  // useEffects
  useEffect(() => {
    dispatch(fetchWebChatChannelList({ brand_id: currentBrand?.brand_id }));
  }, []);
  return webChatChannelListLoading ? (
    <div className="h-full flex items-center justify-center flex-col">
      <Loading3QuartersOutlined spin style={{ fontSize: '2rem' }} />
    </div>
  ) : (
    <div className="h-full px-4">
      {webChatChannelList?.length === 0 ? (
        <Empty
          className="h-full flex items-center justify-center flex-col"
          description={<Text>No Channels Found</Text>}
        />
      ) : (
        <div className="grid content-start h-full gap-2 transition-all">
          {webChatChannelList?.map((item, i) => {
            const isSelected = item.id === selectedWebChatChannel?.id;
            return (
              <div
                key={item.id}
                className={`p-2 w-full flex flex-col border-b border-b-slate-300 border-s-2 border-s-transparent transition-all ${
                  isSelected &&
                  'border-b-[#e1f6e9] bg-[#e1f6e9] border-s-[#05805d]'
                } rounded w-full gap-2 cursor-pointer hover:bg-[#e1f6e9] hover:border-s-[#05805d] hover:border-b-[#e1f6e9]`}
                onClick={() => handleSelectChannel(item)}
              >
                <Text className="text-xs text-nowrap overflow-hidden truncate w-full">
                  {item.name}
                </Text>
                <Tag className="w-fit" color={isSelected ? 'green' : 'default'}>
                  {status[item.status]}
                </Tag>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default WebChatChannels;
